<div class="innerpage-fullwithbanner">
  <h2 class="bighead">Edit Profile</h2>
  <ul class="bread-crumbs">
    <li *ngIf="this._authenticationService.Principal() || this._authenticationService.Seller() || this._authenticationService.Principal1031()">
      <a (click)="onHomeBreadCrumbClick();">
        Home
        <span>|</span>
      </a>
    </li>
    <li *ngIf="!this._authenticationService.Principal() && !this._authenticationService.Seller() && !this._authenticationService.Principal1031()"><a (click)="validationService.redirect('/')">Home<span>|</span></a></li>
    <li>Edit Profile</li>
  </ul>
</div>
<div class="section-margin">
  <div class="container container-lg min-heightcontainer">
    <div class="border-div margin0">
      <h2 class="mainhead "><span class="text">Profile</span></h2>
      <div class="leftsideprofile">
        <div class="profilepic">
          <img #profilePic src="{{userInputModel.ProfilePicPath}}">
          <file-upload (selectedFilesListEmitter)=selectedFilesListEmitter($event) (selectedFilePathEmitter)="selectedFilePathEmitter($event)" [uploadType]="fileUploadType" [clearFilescounter]="clearFiles"></file-upload>
          <a *ngIf="imageIdToDelete != null" href="javascript:void(0);" (click)="openModalForDelete(template,'deletemodal',imageIdToDelete,'the profile picture')" class="deletepic" triggers="hover" tooltip="Remove">

            <i class="icofont icofont-close icon"></i>
          </a>
        </div>
      </div>
      <div class="rightsideprofile margin-bottom-20">
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">First Name<span class="red">*</span></label>
              <input class="form-control" (keydown)="onKeydown($event)" #firstNameinput="ngModel" [(ngModel)]="userInputModel.FirstName" required type="text" maxlength="30">
              <p class="redtext" *ngIf="!showFNSpecCharVal && (firstNameValid && firstNameinput.invalid && firstNameinput.touched)">First name is required </p>
              <p class="redtext" *ngIf="!showFNSpecCharVal && (!firstNameValid)">First name is required </p>
              <p class="redtext" *ngIf="showFNSpecCharVal">{{specCharValMsg}}</p>

            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Last Name<span class="red">*</span></label>
              <input class="form-control" (keydown)="onKeydown($event)" #lastNameinput="ngModel" [(ngModel)]="userInputModel.LastName" required type="text" maxlength="30">
              <p class="redtext" *ngIf="!showLNSpecCharVal && (lastNameValid && lastNameinput.invalid && lastNameinput.touched)">Last name is required </p>
              <p class="redtext" *ngIf="!showLNSpecCharVal && (!lastNameValid)">Last name is required </p>
              <p class="redtext" *ngIf="showLNSpecCharVal">{{specCharValMsg}}</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Email<span class="red">*</span></label>
              <input class="form-control" (keydown)="onKeydown($event)" #emailinput="ngModel" (change)="validateemail()" [disabled]="true" [ngModel]="userInputModel.EmailAddress" type="text" maxlength="100">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Password<span class="red">*</span></label>
              <input class="form-control" (keydown)="onKeydown($event)" [disabled]="true" value="************************************************************************************" type="password" maxlength="250">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Phone<span class="red">*</span></label>
              <input class="form-control" (keydown)="onKeydown($event)" #phoneNumberinput="ngModel" required [(ngModel)]="userInputModel.PhoneNumber" mask='(000) 000-0000' type="text" maxlength="20">
              <p class="redtext" *ngIf="(phoneValid) && phoneNumberinput.invalid && phoneNumberinput.touched">Phone number is required</p>
              <p class="redtext" *ngIf="(!phoneValid)">Phone number is required</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Address Line 1</label>
              <input class="form-control" (keydown)="onKeydown($event)" [(ngModel)]="userInputModel.Address1" type="text" maxlength="75">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Address Line 2</label>
              <input class="form-control" (keydown)="onKeydown($event)" [(ngModel)]="userInputModel.Address2" type="text" maxlength="75">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">State</label>
              <label class="select">
                <select class="form-control" [(ngModel)]="userInputModel.StateId" (change)="bindCity()">
                  <option value="0">--Select--</option>
                  <option *ngFor="let states of statesList" [(ngValue)]="states.Id">{{states.Name}}</option>
                </select>
                <i></i>
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">City</label>
              <label class="select">
                <select class="form-control " [(ngModel)]="userInputModel.CityId">
                  <option value="0">--Select--</option>
                  <option *ngFor="let cities of citiesList" [(ngValue)]="cities.Id">{{cities.Name}}</option>
                </select>
                <i></i>
              </label>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">ZIP</label>
              <input class="form-control" (keydown)="onKeydown($event)" [(ngModel)]="userInputModel.Zip" type="text" maxlength="5">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Role<span class="red">*</span></label>
              <label class="select">
                <select class="form-control" #role="ngModel" [disabled]="isDisableRole" required [(ngModel)]="userInputModel.UserRoleId">
                  <option value="0">--Select--</option>
                  <option *ngFor="let userrole of userRoleList" [(ngValue)]="userrole.id">{{userrole.name}}</option>
                </select>
                <i></i>
              </label>
              <p class="redtext" *ngIf="(roleValid) && userInputModel.UserRoleId ==0 && role.touched">Role is required</p>
              <p class="redtext" *ngIf="(!roleValid)">Role is required</p>
              <input class="form-control" (keydown)="onKeydown($event)" type="text" style="display:none !important;" disabled [ngModel]="userInputModel.UserRole" maxlength="100">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">User Status<span class="red">*</span></label>
              <label class="select">
                <select class="form-control" #Status="ngModel" [disabled]="true" [ngModel]="userInputModel.UserStatus">
                  <option value="0">--Select--</option>
                  <option *ngFor="let userstatus of lookupList" [(ngValue)]="userstatus.id">{{userstatus.description}}</option>
                </select>
                <i></i>
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Company Name</label>
              <input class="form-control" (keydown)="onKeydown($event)" [(ngModel)]="userInputModel.CompanyName" type="text" maxlength="200" autocomplete="off">
            </div>
          </div>
          <div class="col-lg-6 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group" *ngIf="userInputModel.UserRoleId === userRole.Broker || this.userInputModel.UserRoleId == this.userRole.Admin|| this.userInputModel.UserRoleId == this.userRole.SuperAdmin">
              <label class="form-label">LinkedIn</label>
              <input class="form-control" placeholder="https://.." name='validate' #validate='ngModel' [(ngModel)]="userInputModel.UserLinkedInProfile" (keydown)="onKeydown($event)" pattern="^(https?:\/\/?(www|\w\w)\.?linkedin.com/)((in/[^/]+/?)|(pub/[^/]+/((\w|\d)+/?){3}))$" type="text" maxlength="500">
              <div style="color:red" *ngIf="!validate.valid">
                Invalid LinkedIn url
              </div>
              <div style="display:none!important" *ngIf="!validate.valid?linkedinurlvalid(false):linkedinurlvalid(true)">
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="clearfix"></div>
      <div *ngIf="ShowbrokerRegionalLicenses && !_authenticationService.DataEntryStaff()">
        <div class="floatinghead floatinghead-xs clearfix">
          <h2 class="mainhead "><span class="text">Broker Regional Licenses</span></h2>
          <div class="uploadfile  btn  btn-circle btn-green " tooltip="Add Broker Regional Licenses" placement="left">

            <span class="icofont icofont-plus icon" (click)="addFieldValue();"></span>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table basictable">
            <thead>
              <tr>
                <th>#</th>
                <th>State</th>
                <th>License No.</th>
                <th>Expiration Date</th>
                <th>Default</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let field of brokerRegionalLicenses;let i = index">
                <td><p>{{i+1}}</p></td>
                <td>
                  <label class="select">
                    <select class="form-control" [(ngModel)]="field.StateId">
                      <option value="0">--Select--</option>
                      <option *ngFor="let states of statesList" [(ngValue)]="states.Id">{{states.Name}}</option>
                    </select>
                    <i></i>
                  </label>
                </td>
                <td>
                  <input class="form-control" [(ngModel)]="field.BrokerLicense" (keydown)="onKeydown($event)" type="text" maxlength="50">
                </td>
                <td>
                  <div class="textbox-date">
                    <input [(ngModel)]="field.ExpiryDate_Date" (keydown)="onKeydown($event)" placeholder="mm/dd/yyyy" class="form-control" bsDatepicker type="text">
                    <i class="icofont icofont-ui-calendar icon"></i>
                  </div>
                </td>
                <td>
                  <label class="custom-checkbox withoutlabel">
                    <input type="checkbox" (change)="setDefault($event,i)" [(ngModel)]="field.IsDefault" id="{{i}}">

                    <i></i>
                  </label>

                </td>
                <td>
                  <a href="javascript:void(0);" class="remove" tooltip="Remove" (click)="deleteFieldValue(i,field.Id)" placement="top"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                </td>
              </tr>

            </tbody>
            <tfoot>
              <tr *ngIf="brokerRegionalLicenses?.length == 0 ">
                <td colspan="9" class="odd no-data-available">
                  <div class="nodata">
                    <i class="fa fa-exclamation-triangle icon"></i>
                    <p>No Data Available</p>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>


      <br />


      <div class="text-right">
        <button class="btn btn-default btn-lg" (click)="clearFeilds();">Cancel</button>
        <button class="btn btn-success btn-lg" (click)="saveUser();">Save</button>
      </div>
    </div>

    <div class="border-div margin-top-20" *ngIf="IsSeller">
      <div class="margin-top-10">
        <div class="floatinghead clearfix">
          <h2 class="mainhead "><span class="text">Tickers</span></h2>
          <div class="rightside clearfix" *ngIf="IsSeller">
            <a class="filter btn  btn-circle btn-green adduserbtn" href="javascript:void(0);" tooltip="Add Tickers" (click)="openAddTicker(AddTicker,'panlestyle')"><i class="fa fa-plus icon" aria-hidden="true"></i></a>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table basictable">
            <thead>
              <tr>
                <th>Name</th>
                <th>Symbol</th>
                <th>Remove</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of tickers;let i = index">
                <td>
                  <p>{{item.Name}}</p>
                </td>
                <td>
                  <p>{{item.Symbol}}</p>
                </td>
                <td class="whitespacenowrap">
                  <a class="remove" *ngIf="!item.IsDefault" tooltip="Remove" href="javascript:void(0);" (click)="openModalForDeleteTicker(RemoveTicker,'deletemodal',item.Id, i)"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr *ngIf="tickers?.length == 0 ">
                <td colspan="3" class="odd no-data-available">
                  <div class="nodata">
                    <i class="fa fa-exclamation-triangle icon"></i>
                    <p>No Tickers Available</p>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<!--<ng2-toasty [position]="'top-right'"></ng2-toasty>-->
<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Profile Picture</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">Are you sure you want to delete {{deleteTask}}?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="onRemoveImage(imageIdToDelete);modalRef.hide();">Delete</button>
    </div>
  </div>

</ng-template>


<ng-template #AddTicker>
  <app-shared-ticker-add [userId]="currentuserId" (closeModal)="closeAddTickerModal($event)" [modalRef]="modalRefAddTicker"></app-shared-ticker-add>
</ng-template>


<ng-template #RemoveTicker>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Remove Ticker</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefRemoveTicker.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">Are you sure to remove this ticker for the seller ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefRemoveTicker.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="removeTicker();modalRefRemoveTicker.hide();">Remove</button>
    </div>
  </div>
</ng-template>
